

















































import { defineComponent, SetupContext } from '@nuxtjs/composition-api';
export default defineComponent({
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  setup(_props, _context: SetupContext) {
    return {};
  },
});
